import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, FormControlLabel, Typography } from "@mui/material";
import PrimaryCheckbox from "../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";
import { formatTitleCase } from "../../../../utils/formatHelpers";
import { AlertContext } from "../../../Dashboard/Dashboard";
import { CarrierService } from "../../../../services/CarrierService";

export default function CarrierProfileCapabilityType({
  type, 
  value, 
  activeCarrier,
  setActiveCarrier,
  isUpdating,
  setIsUpdating
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [checked, setChecked] = useState(false);

  const formatText = (text) => {
    text = text.replace(/([A-Z])/g, " $1").trim();
    return formatTitleCase(text);
  };

  const handleChange = () => {
    const newValue = !checked;
    setChecked(!checked);
    setIsUpdating(true);

    CarrierService.UpdateCarrierDynamic(instance, activeCarrier.id, type, newValue).then(res => {
      setActiveCarrier(res);
      setIsUpdating(false);
    }).catch(error => {
      setIsUpdating(false);
      warning(error);
    });
  };

  useEffect(() => {
    setChecked(!!value);
  }, [type]);

  return (
    <Box sx={{ display: "flex", marginBottom: "12px" }}>
      <FormControlLabel 
        control={
          <Box sx={{ margin: "0 8px 0px 8px"}}>
            <PrimaryCheckbox 
              checked={checked}
              handleChange={handleChange}
              disabled={true}
            />
          </Box>
        }
        label={
          <Typography variant="body1" sx={{ marginLeft: "5px", color: "black_solid.80"}}>
            {formatText(type)}
          </Typography>
        }
      />
    </Box>
  );
}

CarrierProfileCapabilityType.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.bool,
  activeCarrier: PropTypes.object.isRequired,
  setActiveCarrier: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  setIsUpdating: PropTypes.func.isRequired
};